var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNetSales(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_187431",
    "data-name": "Group 187431",
    transform: "translate(7249 3347)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_63424",
    "data-name": "Path 63424",
    d: "M4.137,451.841a.591.591,0,0,0-.591-.591H.591a.591.591,0,0,0-.591.591v4.768a.591.591,0,0,0,.591.591H3.546a.591.591,0,0,0,.591-.591Zm0,0",
    transform: "translate(-7249 -3784.2)",
    fill: "#7D96FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63425",
    "data-name": "Path 63425",
    d: "M173.546,338.75h-2.955a.591.591,0,0,0-.591.591v8.314a.591.591,0,0,0,.591.591h2.955a.591.591,0,0,0,.591-.591v-8.314A.591.591,0,0,0,173.546,338.75Zm0,0",
    transform: "translate(-7413.699 -3675.246)",
    fill: "#7D96FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63426",
    "data-name": "Path 63426",
    d: "M342.3,301.25h-2.955a.591.591,0,0,0-.591.591v9.5a.591.591,0,0,0,.591.591H342.3a.591.591,0,0,0,.591-.591v-9.5A.591.591,0,0,0,342.3,301.25Zm0,0",
    transform: "translate(-7577.188 -3638.928)",
    fill: "#7D96FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63427",
    "data-name": "Path 63427",
    d: "M512.3,151.25h-2.955a.591.591,0,0,0-.591.591v14.224a.591.591,0,0,0,.591.591H512.3a.591.591,0,0,0,.591-.591V151.841A.591.591,0,0,0,512.3,151.25Zm0,0",
    transform: "translate(-7741.887 -3493.656)",
    fill: "#7D96FF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_63428",
    "data-name": "Path 63428",
    d: "M12.382,13a1.75,1.75,0,0,0,1.685-2.249l2.282-1.626a1.731,1.731,0,0,0,1.012.329,1.759,1.759,0,0,0,1.734-1.537l2.337-.5a1.749,1.749,0,0,0,1.494.852,1.771,1.771,0,0,0,1.626-2.441l2.8-2.514a1.724,1.724,0,0,0,.843.227,1.776,1.776,0,1,0-1.626-1.105l-2.8,2.514a1.724,1.724,0,0,0-.843-.227,1.759,1.759,0,0,0-1.734,1.537l-2.337.5a1.749,1.749,0,0,0-1.494-.852,1.75,1.75,0,0,0-1.685,2.249L13.394,9.785a1.731,1.731,0,0,0-1.012-.329,1.773,1.773,0,0,0,0,3.546Zm0,0",
    transform: "translate(-7259.29 -3347)",
    fill: "#7D96FF"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetSales);
export default __webpack_public_path__ + "static/media/net-sales.b50807eed6c708c422150156e6fabc52.svg";
export { ForwardRef as ReactComponent };